import { AutoEq } from '../MLJobPayloads'
import { BaseMLModelJob } from './BaseMLModelJob'
import { Attachment } from './common'

export type StemFileUrls = { instrument: string; url: string }[]

export enum SplitInstrumentalMethod {
  VOC_FT = 'voc_ft',
  DEMUCS_4 = 'demucs_4',
  BS_ROFORMER_VIPERX = 'bs_roformer_viperx',
  MEL_ROFORMER_KIMBERLEY = 'mel_roformer_kimberley'
}

export enum MLStemSplitterJobType {
  YOUTUBE = 'youtube',
  AUDIO = 'audio'
}

export enum MLStemSplitterPrimaryModelType {
  SPLIT_INSTRUMENTAL = 'split_instrumental',
  DEHARMONY = 'deharmony',
  DEREVERB = 'dereverb',
  DENOISE = 'denoise',
  DEBREATH = 'debreath',
  SPLIT_4_STEMS = 'split_4_stems'
}

export interface MLStemSplitterJobMetadata {
  youtubeLink?: string
  dereverb?: boolean
  deharmony?: boolean
  denoise?: boolean
  debreath?: boolean
  splitInstrumental?: boolean
  split4Stems?: boolean
  splitInstrumentalMethod?: SplitInstrumentalMethod // when splitInstrumental is true, this will tell you what model is used, defaulting to voc_ft
  autoEq?: AutoEq
  startTimeMs?: number
  endTimeMs?: number
}

export interface MLStemSplitterJob extends BaseMLModelJob {
  inputFile: Attachment
  originalInputFileName: string | null
  vocalAudioFile: Attachment | null
  lossyVocalAudioFile: Attachment | null
  backingAudioFile: Attachment | null
  stemFileUrls: StemFileUrls
  lossyStemFileUrls: StemFileUrls
  metadata: MLStemSplitterJobMetadata
  type: MLStemSplitterJobType
  audioDurationMs: number | null
  primaryJobType: MLStemSplitterPrimaryModelType | null
  isZeroShotPreprocessing: boolean
  preprocessingVoiceModelId: number | null
  audioAnalysisJobId: number | null
}
